import { api } from './api';

const getGroupsList = async () => {
    const response = await api({
        url: `Groups/getall`,
        method: 'GET',
    });
    return response.data;
};

const getRoleList = async () => {
    const response = await api({
        url: `Groups/getRoleList`,
        method: 'GET',
    });
    return response.data;
};

const getAllClaims = async ({body, pageNumber = 1, pageSize = 10}) => {
    const response = await api({
        url: `Groups/getPagedList`,
        method: 'GET',
        params: {
            page: pageNumber,
            pageSize,
            ...body,
        },
    });
    return response.data;
};

const getGroupClaims = async ({id}) => {
    const response = await api({
        url: `GroupClaims/getgroupclaimsbygroupid`,
        method: 'GET',
        params: {
            groupId: id,
        },
    });
    return response.data;
};

const addGroup = async (data) => {
    const response = await api({
        url: `Groups/add`,
        method: 'POST',
        data,
    });
    return response.data;
};

const updateGroup = async (data) => {
    const response = await api({
        url: `Groups/update`,
        method: 'PUT',
        data,
    });
    return response.data;
};

const deleteGroup = async (data) => {
    const response = await api({
        url: `Groups/delete`,
        method: 'DELETE',
        params:{
            customerId: window.customerId
        },
        data: {
            ...data,
            customerId: window.customerId
        },
    });
    return response.data;
};

const addGroupClaims = async (data) => {
    const response = await api({
        url: `GroupClaims/add`,
        method: 'POST',
        data,
    });
    return response.data;
};

const deleteGroupClaims = async ({id}) => {
    const response = await api({
        url: `GroupClaims/delete`,
        method: 'DELETE',
        params:{
            customerId: window.customerId
        },
        data: {
            id,
            customerId: window.customerId
        },
    });
    return response.data;
};

const getCheckList = async (userId) => {
    const response = await api({
        url: `Groups/getCheckList`,
        method: 'GET',
        params: {
            userId,
        },
    });
    return response.data;
};

const groupsServices = {
  getGroupsList,
  getGroupClaims,
  addGroup,
  updateGroup,
  deleteGroup,
  addGroupClaims,
  deleteGroupClaims,
  getRoleList,
  getAllClaims,
  getCheckList,
};

export default groupsServices;
